
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export function ContractError() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="p-6 bg-destructive/10 rounded-md">
      <h1 className="text-xl font-medium text-destructive">{t('errorLoadingContract')}</h1>
      <p className="mt-2">
        {t('contractNotFound')}
      </p>
      <button
        onClick={() => navigate("/contracts")}
        className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-md"
      >
        {t('backToContracts')}
      </button>
    </div>
  );
}

